import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import {
  OrderDirectory,
  Plan,
  PlanningDetails
} from '@authority-labs/api-interfaces';
import { PlansComponent } from '../plans/plans.component';

const DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY'
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY'
  }
};

@Component({
  selector: 'authority-labs-integration-plans',
  templateUrl: './integration-plans.component.html',
  styleUrls: ['./integration-plans.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'he-IL' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMAT }
  ]
})
export class IntegrationPlansComponent extends PlansComponent {
  @Input() orderId: number;
  @Input() orderDirectory: OrderDirectory;
  @Input() planningDetails: PlanningDetails;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  displayedColumns = [
    'name',
    'identificationCode',
    'creator',
    'date',
    'conclusion',
    'notes'
  ];

  selectedPlan: Plan;

  protected override buildColumns(): void {
    const cols = [
      'name',
      'identificationCode',
      'creator',
      'date',
      'conclusion',
      'notes'
    ];
    if (!(this.readonly || this.printPreview)) {
      cols.unshift('drag');
      cols.push('file', 'actions');
    } else if (this.readonly && !this.printPreview) {
      cols.push('file');
    }
    this.displayedColumns = cols;
  }
}
